import { Card } from "@volt_developers/components";

import type { ReactNode } from "react";

export interface SecretCardItemWrapperProps {
  generateButton: ReactNode;
  children?: ReactNode;
  "data-testid"?: string;
  label?: ReactNode;
}

export function SecretCardItemWrapper({
  children,
  "data-testid": dataTestId,
  generateButton,
  label,
}: SecretCardItemWrapperProps) {
  return (
    <Card.Item label={label} data-testid={dataTestId} labelSx={{ mb: 1 }}>
      {children}
      {generateButton}
    </Card.Item>
  );
}
